import { render, staticRenderFns } from "./ProposedCandidate.vue?vue&type=template&id=99cff040&scoped=true&"
import script from "./ProposedCandidate.vue?vue&type=script&lang=js&"
export * from "./ProposedCandidate.vue?vue&type=script&lang=js&"
import style0 from "./ProposedCandidate.vue?vue&type=style&index=0&id=99cff040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cff040",
  null
  
)

export default component.exports